module.exports = __webpack_public_path__ + "img/success-round.cc981125.svg";